<template>
  <el-dialog :visible.sync="visible" :title="$t('参与用户上传')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-upload
      :action="url"
      :file-list="fileList"
      drag
      multiple
      :headers="myHeaders"
      :before-upload="beforeUploadHandle"
      :on-success="successHandle"
      class="text-center">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" v-html="$t('将文件拖到此处或点击上传')"></div>
      <div class="el-upload__tip" slot="tip">只支持xlsx格式文件 !</div>
      <div class="el-upload__tip" slot="tip"><a href="https://static.chwenda.com/source/downloadModel/活动参与名单模板.xlsx">下载模板</a></div>
    </el-upload>
  </el-dialog>
</template>

<script>
import Url from '@/views/crs/util/url'
import { getToken } from '@/utils/auth' // get token from cookie
export default {
  props: ['gameRankId'],
  data () {
    return {
      visible: false,
      url: '',
      num: 0,
      fileList: [],
      myHeaders:{Authorization:getToken('CRS')}
    }
  },
  methods: {
    init () {
      this.visible = true
      this.url = `${Url.gameRank.base}/activity/gameRankUser/importgameRankUser?gameRankId=`+this.gameRankId
      this.num = 0
      this.fileList = []
    },
    // 上传之前
    beforeUploadHandle (file) {
      if (!/.+\.xlsx$/.test(file.name)) {
        this.$message.error(this.$t('upload.tip', { 'format': 'xlsx' }))
        return false
      }
      this.num++
    },
    // 上传成功
    successHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.fileList = fileList
      this.num--
      if (this.num === 0) {
        this.$message({
          message: this.$t('上传成功'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
          }
        })
      }
    }
  }
}
</script>
